<template>
  <div :style="{backgroundColor: $finColors.background}" class="fin-profile-portrait py-4">
    <v-row>
      <v-col cols="12" md="8">
        <div class="headline-section pb-3">
          {{ title }}
        </div>
        <div class="portrait-text">
          {{ companyPortraitText }}
        </div>
      </v-col>

      <v-col cols="12" md="4">
        <div class="pb-3">
          <div class="company-header pb-1 pt-2">
            {{ nameTitle }}
          </div>
          <div class="company-text">
            {{ companyPortraitName }}
          </div>
        </div>
        <div class="pb-3">
          <div class="company-header pb-1">
            {{ addressTitle }}
          </div>
          <div v-if="companyPortrait && companyPortrait.address" class="company-text">
            <p v-if="companyPortrait.address.street"> {{ companyPortrait.address.street }} </p>
            <p v-if="companyPortrait.address.city && companyPortrait.address.country">
              {{ companyPortrait.address.city + empty + companyPortrait.address.country }} </p>
          </div>
          <p v-else> {{ empty }} </p>
        </div>
        <div class="pb-3">
          <div class="company-header pb-1">
            {{ contactTitle }}
          </div>
          <div v-if="companyPortrait && companyPortrait.contact" class="company-text font-weight-bold">
            <p> {{ companyPortrait.contact.phone }} </p>
            <p v-if="companyPortrait.contact.email"> {{ companyPortrait.contact.email }} </p>
            <p v-if="companyPortrait.contact.web"> {{ companyPortrait.contact.web }} </p>
          </div>
          <p v-else> {{ empty }} </p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {

  /**
   * @property {Object} contact
   * @property {String} portrait
   */

  name: "finProfilePortrait",
  props: {
    companyPortrait: {
      type: Object
    }
  },
  data() {
    return {
      title: 'Unternehmensportrait',
      nameTitle: 'Name',
      addressTitle: 'Adresse',
      contactTitle: 'Kontakt',
      portraitNotAvailable: 'Kein Unternehmensportrait verfügbar',
      empty: ' - '
    }
  },

  computed: {
    companyPortraitName() {
      if (this.companyPortrait && this.companyPortrait.name) {
        return this.companyPortrait.name
      } else return this.empty
    },
    companyPortraitText() {
      if (this.companyPortrait && this.companyPortrait.portrait) {
        return this.companyPortrait.portrait
      } else return this.portraitNotAvailable
    },
    phoneNumber() {
      if (this.companyPortrait.contact) {
        let phoneNumber = this.companyPortrait.contact.phone
        try {
          let formattedPhoneNumber = this.phoneNumber.replace(/\.|[-]|[/]/g, ' ')
          formattedPhoneNumber = formattedPhoneNumber.replace(/[+]/g, '+')
          return formattedPhoneNumber
        } catch (e) {
          return phoneNumber
        }
      } else return this.empty
    }
  }
}
</script>

<style lang="scss" scoped>
.portrait-text {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
}

.company-header {
  font-size: 12.5px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 1px;
}

.company-text, p {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  margin: 0;
}

</style>
